import { OrchestratorContext } from "../app/OrchestratorContext/OrchestratorContext.js";
import { useContext } from "react";
const useOrchestrator = () => {
    const orchestrator = useContext(OrchestratorContext)?.orchestrator;
    if (!orchestrator)
        return undefined;
    return {
        on: orchestrator.on.bind(orchestrator),
        off: orchestrator.off.bind(orchestrator),
        hasQuery: orchestrator.hasQuery.bind(orchestrator),
        runCommand: orchestrator.runCommand.bind(orchestrator),
        runQuery: orchestrator.runQuery.bind(orchestrator),
        publish: orchestrator.publish.bind(orchestrator)
    };
};
export default useOrchestrator;
